import { inject, Injectable } from "@angular/core";
import { BillIcon, CustomerServiceCenterIcon, DeveloperIcon, fax, IntelligentMiningIcon, logManagementIcon, MassSendingIcon, OperationalToolsIcon, UserManagement, WabaManagement, WABARegisterIcon } from "@app/common/customize.icon";
import { NzIconService } from "ng-zorro-antd/icon";

@Injectable({
  providedIn: 'root'
})
export class AddCustomizeIconService {
  nzIconService = inject(NzIconService);

  addIcon() {
    this.nzIconService.addIconLiteral('ng-zorro:massSending', MassSendingIcon);
    this.nzIconService.addIconLiteral('ng-zorro:customer-service-center', CustomerServiceCenterIcon);
    this.nzIconService.addIconLiteral('ng-zorro:developer', DeveloperIcon);
    this.nzIconService.addIconLiteral('ng-zorro:waba-register', WABARegisterIcon);
    this.nzIconService.addIconLiteral('ng-zorro:log-managent', logManagementIcon);
    this.nzIconService.addIconLiteral('ng-zorro:user-management', UserManagement);
    this.nzIconService.addIconLiteral('ng-zorro:bill', BillIcon);
    this.nzIconService.addIconLiteral('ng-zorro:operational-tools', OperationalToolsIcon);
    this.nzIconService.addIconLiteral('ng-zorro:intelligent-mining', IntelligentMiningIcon);
    this.nzIconService.addIconLiteral('ng-zorro:waba-management', WabaManagement);
    this.nzIconService.addIconLiteral('ng-zorro:fax', fax);
  }
}